import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {setPageMessage} from '../../../actions/pageMessageActions';
import {recordBigQueryEvent, submitConfirm} from '../../../actions/paymentActions/threedsActions';
import {stopOrderProcessing} from '../../../actions/site-actions';
import Translation from '../../../lang/Translation';
import Track from '../../../utils/tracking';
import Spinner from '../../ui/Spinner';
import PostToIframe from '../ProviderAgnostic/PostToIframe';
import '../ThreeDSecureRedirect.scss';
import './CheckoutcomRedirect.scss';

const PROVIDER = 'CHECKOUT_COM';

export class Checkoutcom3DSRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {loading: true};
  }
  
  componentDidMount() {
    window.addEventListener('message', this.messageCallback, false);
    this.timer = setTimeout(() => {
      try {
        recordBigQueryEvent('DataCollectionCompleted', PROVIDER, [{name: 'result', value: 'timeout'}], []);
      } catch (error) {
        Track.track(error);
      }
      this.props.submitConfirm(this.props.providerTransactionId);
    }, 600000);
  }
  
  componentWillUnmount() {
    this.removeListener();
  }
  
  removeListener = () => {
    window.removeEventListener('message', this.messageCallback);
  };
  
  messageCallback = (event) => {
    let eventData = event.data;
    if (typeof eventData === 'string') {
      try {
        eventData = JSON.parse(event.data);
      } catch (error) {
        Track.error(`JSON parse error in Checkoutcom3DSRedirect. ${error}`);
        eventData = null;
      }
    }
    
    if (!eventData?.transaction_id) return;
    
    const {transaction_id} = eventData;
    this.removeListener();
    
    this.props.submitConfirm(transaction_id, true);
    
    recordBigQueryEvent('1ChallengeCompleted', PROVIDER,
      [{name: 'result', value: 'success'}], []);
  };
  
  handleOnLoadComplete = () => {
    try {
      recordBigQueryEvent('1ChallengeInitiated', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
    this.setState({loading: false});
  };
  
  handleOnError = () => {
    const errorMessage = 'Error loading Checkoutcom 3DS Redirect frame';
    Track.track(new Error(errorMessage));
    this.props.setPageMessage('Sorry, we couldn\'t contact your bank to verify your payment. Please try again.');
    this.props.stopOrderProcessing();
    this.props.submitConfirm(this.props.providerTransactionId);
    try {
      recordBigQueryEvent('1ChallengeCompleted', PROVIDER,
        [{name: 'result', value: 'error'}], [{type: 'loading', value: errorMessage}]);
    } catch (error) {
      Track.track(error);
    }
  }
  
  render() {
    const threeDSecureData = {
      issuerURL: this.props.issuerURL,
      PaReq: this.props.oneTime3DSToken,
      TermUrl: this.props.providerRedirectionInterceptor,
      MD: this.props.providerTransactionId,
    };
    
    // so, if i dont do following check it will emit event at least 3 times. it re-renders whole thing every time
    // this.state.loading value changes.
    if (this.state.loading) {
      try {
        recordBigQueryEvent('1ChallengeRequired', PROVIDER);
      } catch (error) {
        Track.track(error);
      }
    }
    
    return (
      <div className="Checkoutcom3DSRedirect">
        {this.state.loading && (
          <div className="ThreeDSecure__loading">
            <Spinner size="small" />
            <br />
            <Translation>loading.security.check</Translation>
          </div>
        )}
        
        <PostToIframe
          postURL={threeDSecureData.issuerURL}
          formFields={{
            PaReq: threeDSecureData.PaReq,
            TermUrl: threeDSecureData.TermUrl,
            MD: threeDSecureData.MD,
          }}
          onError={this.handleOnError}
          onLoad={this.handleOnLoadComplete}
        />
      </div>
    );
  }
}

Checkoutcom3DSRedirect.propTypes = {
  // Actions
  stopOrderProcessing: PropTypes.func.isRequired,
  setPageMessage: PropTypes.func.isRequired,
  submitConfirm: PropTypes.func.isRequired,
};

const actions = {
  stopOrderProcessing,
  setPageMessage,
  submitConfirm,
};

export default connect(null, actions)(Checkoutcom3DSRedirect);
